import styled from 'styled-components';

export const Link = styled.a`
  width: 300px;
  height: 64px;
  min-height: 64px;
  margin: 15px auto;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-image: url(${props => props.logoUrl});
`;
